module.exports = __webpack_public_path__ + "img/icon_l_xg_act.c0fbeca9.png";